module.exports = __webpack_public_path__ + "static/img/ent-detail-38.d70735e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-38.jpg
// module id = 1hnq
// module chunks = 51